
  import { Component, Vue } from 'vue-property-decorator';

  @Component
  export default class BadRequest extends Vue {
    data() {
      return {
        errorMessage: this.$route.query.message
      };
    };
  }
